import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'product',
        title: 'Ürün İsmi',
        rules: {required: true},
        modal: ['name'],
        data: ['Name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'code',
        title: 'Stok Kodu',
        rules: {required: true},
        modal: ['barcode'],
        data: ['Barcode'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'unit',
        title: 'Birim',
        rules: {required: true},
        modal: ['unit'],
        data: ['Unit'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['Description'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/stock.js